const constant = {
  baseUrl: "https://staging-api.bydautoindia.com/",
  imageUrl: "https://byd-assets.s3.us-east-2.amazonaws.com/staging/",
};

export default constant;
